import {
    CalendarOutlined,
    ClearOutlined,
    DownOutlined,
    FileExcelOutlined,
    FilePdfOutlined,
    FilterFilled,
    LayoutOutlined, QrcodeOutlined, RadiusSettingOutlined,
    TableOutlined,
    UnorderedListOutlined,
    UploadOutlined
} from '@ant-design/icons'
import {
    Button,
    Card,
    Col,
    Divider,
    Dropdown,
    Input,
    List,
    message,
    Modal,
    Popover,
    Radio,
    Row,
    Select,
    Spin,
    Tag,
    Typography
} from 'antd'
import React from 'react'
import { withRouter } from 'react-router'

import axios from "axios"
import PropTypes from "prop-types"
import '../asset/less/Pieces.less'
import {URL_BULK_UPLOAD_UPDATE, URL_LOGIN} from "../const"
import CalendarView from "./base/CalendarView"
import { getFiltersByType } from './base/filters/FilterUtils'
import GalleryView from "./base/GalleryView"
import HttpError from './base/HttpError'
import ManageColumnsModal from "./base/ManageColumnsModal"
import ExportExcelColumnsSelect from './base/selects/ExportExcelColumnsSelect'
import ImportExcelColumnsSelect from "./base/selects/ImportExcelColumnsSelect"
import TableView from "./base/TableView"
import MyPagination from "./MyPagination"
import MyTitle from "./MyTitle"
import ExportInventoryReport from "./piece/ExportInventoryReport"
import PlanExpireModal from "./base/PlanExpireModal";
import {connect} from "react-redux";
import {userLogout} from "../action/user";
import {is_premium_plan} from "../app/role";
import ExportInventoryQRCode from "./piece/ExportInventoryQRCode";
import ImportAddExcelColumnsSelect from "./base/selects/ImportAddExcelColumnsSelect";

const {Title} = Typography
const {Option} = Select
const {Meta} = Card

const GALLERY_LAYOUT = 'gallery'
const TABLE_LAYOUT = 'table'
const CALENDAR_LAYOUT = 'calendar'

const EXPORT_PDF = 'pdf'
const EXPORT_EXCEL = 'excel'
const EXPORT_CSV = 'csv'
const EXPORT_INVENTORY_REPORT = 'inventory_report'
const EXPORT_QR_CODE = 'qr_code'

const IMPORT_EXCEL = 'excel'
const IMPORT_CSV = 'csv'
const IMPORT_BULK_UPLOAD = 'bulk_upload'
const IMPORT_ADD_EXCEL = 'import_add_excel'

const ViewIcons = {
    gallery: <TableOutlined/>,
    table: <UnorderedListOutlined/>,
    calendar: <CalendarOutlined/>
}

function getDefault(num, default_num) {
    if (isNaN(num)) {
        return default_num;
    }
    return num;
}

const viewRatioOptions = [
    {
        key: '1',
        label: 'default',
    },
    {
        key: '2',
        label: '1:1',
    },
    {
        key: '3',
        label: '3:2',
    },
    {
        key: '4',
        label: '16:9',
    },
];

const KEY_PAGE_SIZE = 'pageSize'
const KEY_CURRENT = 'current'
const KEY_ORDER_BY = 'orderBy'
const KEY_FILTERS = 'filters'
const KEY_SEARCH = 'search'
const KEY_ASPECT_RATIO_KEY = 'aspectRatioKey'
const KEY_VIEW_LAYOUT = 'viewLayout'

@connect(
    (state) => ({
        role: state.user.info.role,
        plan: state.user.plan
    }),
    {userLogout}
)
class GalleryTablePanel extends React.Component {
    constructor(props) {
        super(props)
        this.prefix = props.name + (props.nameSuffix || '')
        this.query = new URLSearchParams(this.props.location.search)
        let search = ''
        let pageSize = this.loadCache(KEY_PAGE_SIZE + this.props.artistId) || props.pageSize
        let currentPage = this.loadCache(KEY_CURRENT + this.props.artistId) || props.current
        let orderBy = this.loadCache(KEY_ORDER_BY + this.props.artistId) || props.defaultSortOption
        if (orderBy === '[object Object]') {
            orderBy = props.defaultSortOption
        }
        let filters = this.loadJsonCache(KEY_FILTERS + this.props.artistId) || {}
        let aspectRatioKey = this.loadCache(KEY_ASPECT_RATIO_KEY + this.props.artistId) || '1'
        this.viewOptions = props.viewOptions ?? []
        let viewLayout = this.loadCache(KEY_VIEW_LAYOUT + this.props.artistId)
        if (!viewLayout || !this.viewOptions.includes(viewLayout) && this.viewOptions.length > 0) {
            viewLayout = this.viewOptions[0]
        }

        try {
            pageSize = parseInt(pageSize)
            pageSize = getDefault(pageSize, 12)
        } catch (e) {
            pageSize = 12
        }

        try {
            currentPage = parseInt(currentPage)
            currentPage = getDefault(currentPage, 1)
        } catch (e) {
            currentPage = 1
        }

        let initDataArr = []

        let initModalVisible = {}
        initModalVisible[EXPORT_EXCEL] = false;
        initModalVisible[EXPORT_PDF] = false;
        initModalVisible[EXPORT_CSV] = false;
        initModalVisible[EXPORT_INVENTORY_REPORT] = false;
        initModalVisible[EXPORT_QR_CODE] = false;
        this.state = {
            viewLayout: viewLayout,
            selectedItems: [],
            loading: false,
            actionLoading: false,
            data: initDataArr,
            rawData: [],
            pageSize: pageSize,
            current: currentPage,
            total: 0,
            exportPopoverVisible: false,
            exportModalVisible: initModalVisible,
            planModalVisible: false,
            importPopoverVisible: false,
            importModalVisible: false,
            importAddModalVisible: false,
            manageColumnsModalVisible: false,
            order: orderBy,
            search: search,
            filters: filters,
            aspectRatioKey: aspectRatioKey,
            columns: props.columns ?? [],
            allColumns: props.allColumns ?? (props.columns ?? [])
        }

        if (this.props.onDataUpdate) {
            this.props.onDataUpdate([])
        }
        this.allSelectItems = []
        this.requestDataToken = axios.CancelToken.source()
        this.actionToken = axios.CancelToken.source()
    }

    setCache(key, value) {
        localStorage.setItem(this.prefix + '_' + key, value)
    }

    setJsonCache(key, object) {
        try {
            let str = JSON.stringify(object)
            localStorage.setItem(this.prefix + '_' + key, str)
        } catch (e) {
        }
    }

    loadCache(key) {
        try {
            return localStorage.getItem(this.prefix + '_' + key).toString()
        } catch (e) {
            return ""
        }
    }

    loadJsonCache(key) {
        try {
            let string = localStorage.getItem(this.prefix + '_' + key)
            return JSON.parse(string)
        } catch (e) {
            return {}
        }
    }

    removeCache(key) {
        localStorage.removeItem(this.prefix + '_' + key)
    }

    componentDidMount() {
        this.updateData()
    }

    componentWillUnmount() {
        if (this.state.loading) {
            if (this.requestDataToken && this.requestDataToken.cancel)
                this.requestDataToken.cancel("cancel")
            this.setState({
                loading: false
            })
        }
        if (this.state.actionLoading) {
            this.actionToken.cancel("cancel")
            this.setState({
                actionLoading: false
            })
        }
    }

    onPaginationChange(page) {
        this.setState(
            {
                current: page
            },
            this.updateData
        )
        this.setCache(KEY_CURRENT + this.props.artistId, page)
    }

    onShowSizeChange(current, pageSize) {
        this.setState(
            {
                current: 1,
                pageSize: pageSize
            },
            this.updateData
        )
        this.setCache(KEY_CURRENT + this.props.artistId, 1)
        this.setCache(KEY_PAGE_SIZE + this.props.artistId, pageSize)
    }

    updateData = () => {
        this.setState({loading: true})
        this.props
            .requestData(this.state.current, this.state.pageSize, this.state.order, this.state.filters, this.state.search,
                this.requestDataToken)
            .then((response) => {
                if (!response || !response.data || !response.data.results) {
                    return
                }

                this.setCache(KEY_CURRENT + this.props.artistId, this.state.current)
                this.setCache(KEY_PAGE_SIZE + this.props.artistId, this.state.pageSize)
                this.setCache(KEY_ORDER_BY + this.props.artistId, this.state.order)
                this.setJsonCache(KEY_FILTERS + this.props.artistId, this.state.filters)
                this.setCache(KEY_SEARCH + this.props.artistId, this.state.search)

                let dataResults = response.data.results;

                if (this.props.dataOrderJson) {
                    try {
                        const order_array = JSON.parse(this.props.dataOrderJson)
                        if (order_array.length > 0) {
                            let order_json = {}
                            order_array.forEach((order) => {
                                Object.keys(order).forEach((key) => {
                                    order_json[key] = order[key]
                                })
                            })
                            dataResults = dataResults.sort((a, b) => {
                                return order_json[a] - order_json[b]
                            })
                        }
                    } catch (e) {
                    }
                }

                let data = []
                dataResults.forEach((item) => {
                    data.push({
                        ...item,
                    })
                })

                this.setState({
                    loading: false,
                    data: data,
                    rawData: dataResults,
                    total: response.data.count ?? dataResults.length
                })
                this.allSelectItems = data
                if (this.state.selectedItems.length > 0) {
                    const availableArray = data.filter((item) => (
                        this.state.selectedItems.filter((d) => (d.id === item.id)).length > 0
                    ));
                    this.setState({
                        selectedItems: availableArray
                    })
                }
                if (this.props.onDataUpdate) {
                    this.props.onDataUpdate(dataResults)
                }
            })
            .catch((error) => {
                if(error && error.response && error.response.status === 404) {
                    this.removeCache(KEY_CURRENT + this.props.artistId)
                }
                if (axios.isCancel(error)) {
                    return
                }
                HttpError(error)
            }).finally(() => {
            this.setState({
                loading: false
            })
        })
    }

    deleteData = (id) => {
        if (!this.props.deleteData) return
        this.unSelectAllData()
        this.setState({actionLoading: true})

        this.props
            .deleteData(id)
            .then((response) => {
                message.success('Delete successfully!').then((r) => {
                })
                const updateRawData = this.state.rawData.filter((v) => {
                    return v.id !== id
                })
                this.setState({
                    data: this.state.data.filter((v) => {
                        return v.id !== id
                    }),
                    rawData: updateRawData
                })
                if (this.props.onDataUpdate) {
                    this.props.onDataUpdate(updateRawData)
                }
            })
            .catch((error) => {
                HttpError(error)
            })
            .finally(() => {
                this.setState({
                    actionLoading: false,
                })
            })
    }

    bulkEditData = (columns, dataArray) => {
        this.unSelectAllData()
        if (!this.props.bulkUpdateData) {
            message.error("Not supported").then(r => {
            })
            this.setState({
                importModalVisible: false
            })
            return
        }
        this.setState({actionLoading: true, importModalVisible: false})

        this.props
            .bulkUpdateData(columns, dataArray, this.actionToken)
            .then((response) => {
                message.success('Updated successfully, please refresh!').then((r) => {
                })
            })
            .catch((error) => {
                HttpError(error)
            })
            .finally(() => {
                this.setState({
                    actionLoading: false,
                })
            })
    }

    bulkAddData = (columns, dataArray) => {
        this.unSelectAllData()
        if (!this.props.bulkAddData) {
            message.error("Not supported").then(r => {
            })
            this.setState({
                importAddModalVisible: false
            })
            return
        }
        this.setState({actionLoading: true, importAddModalVisible: false})

        this.props
            .bulkAddData(columns, dataArray, this.actionToken)
            .then((response) => {
                message.success('Bulk add successfully, please refresh!').then((r) => {
                })
            })
            .catch((error) => {
                HttpError(error)
            })
            .finally(() => {
                this.setState({
                    actionLoading: false,
                })
            })
    }

    selectAllData = (checked) => {
        if (checked) {
            this.setState({selectedItems: this.allSelectItems})
        } else {
            this.unSelectAllData()
        }
    }

    unSelectAllData = () => {
        this.selectDataArray([])
    }

    selectData = (checked, element) => {
        if (checked) {
            if (this.state.selectedItems.filter((item) => (item.id === element.id)).length === 0)
                this.selectDataArray([...this.state.selectedItems, element])
        } else {
            const newState = this.state.selectedItems.filter((item) => {
                return item.id !== element.id
            })
            this.selectDataArray(newState)
        }
    }

    selectDataArray = (elements) => {
        this.setState({selectedItems: elements})
    }

    clearAllFilter = (ins) => {
        ins.setState(
            {
                search: '',
                filters: {}
            },
            ins.updateData
        )
    }

    logout = () => {
        this.props.userLogout()
        this.props.history.replace({pathname: URL_LOGIN})
    }

    render() {
        function bottomPagination(ins) {
            return (
                <>
                    <Row justify='center' style={{marginTop: 12}}>
                        <MyPagination
                            showQuickJumper
                            showSizeChanger={true}
                            total={ins.state.total}
                            current={ins.state.current}
                            defaultPageSize={ins.state.pageSize}
                            pageSize={ins.state.pageSize}
                            showTotal={(total) => `Total ${total} items`}
                            onChange={ins.onPaginationChange.bind(ins)}
                            onShowSizeChange={ins.onShowSizeChange.bind(ins)}
                        />
                    </Row>
                </>
            )
        }

        function topPagination(ins) {
            return (
                <Col style={{marginTop: 12, float: 'right'}}>
                    <Row justify='center'>
                        <MyPagination
                            showQuickJumper
                            showSizeChanger={true}
                            total={ins.state.total}
                            current={ins.state.current}
                            defaultPageSize={ins.state.pageSize}
                            pageSize={ins.state.pageSize}
                            onChange={ins.onPaginationChange.bind(ins)}
                            onShowSizeChange={ins.onShowSizeChange.bind(ins)}
                            pageSizeOptions={ins.props.pageSizeOptions}
                        />
                    </Row>
                </Col>
            )
        }

        function searchLayout(ins) {
            if(ins.props.disableSearch) return null
            return (
                <Col style={{marginTop: 18, float: 'right'}} data-tut="reactour__search">
                    <Input.Search
                        defaultValue={ins.state.search}
                        placeholder='Search'
                        onSearch={(value) => {
                            ins.setState(
                                {
                                    search: value,
                                    current: 1
                                },
                                ins.updateData
                            )
                        }}
                    />
                </Col>
            )
        }

        function sortLayout(ins) {
            if (!ins.props.sortOptions || ins.props.sortOptions.length === 0) return null
            return (
                <>
                    <Col data-tut="reactour__sort">
                        <Select
                            defaultValue={ins.state.order}
                            dropdownMatchSelectWidth={false}
                            listHeight={512}
                            onChange={(value) => {
                                ins.setState(
                                    {
                                        order: value
                                    },
                                    ins.updateData
                                )
                            }}
                        >
                            {ins.props.sortOptions?.map((option) => {
                                return (
                                    <Option key={option.text} value={option.value}>
                                        {option.icon} {option.text}
                                    </Option>
                                )
                            })}
                        </Select>
                    </Col>
                </>
            )
        }

        function selectedNumsLayout(ins) {
            if (!ins.state.selectedItems || ins.state.selectedItems.length === 0) return null
            if (!ins.state.data || ins.state.data.length === 0) return null
            return <>
                <Col>{ins.state.selectedItems.length.toString() + " of " + ins.state.data.length.toString() + " Selected"}</Col>
            </>
        }

        function topActionLayout(ins) {

            function getSortLayout() {
                const Layout = ins.props.sortLayout
                return (
                    <Layout data-tut="reactour__sort" order={ins.state.order} onChange={(value) => {
                        ins.setState({
                            order: value
                        }, ins.updateData)
                    }}/>
                )
            }

            return (
                <Row align='middle' gutter={{xs: 8, sm: 16, md: 24}} style={{marginTop: 4}}>
                    <Divider style={{marginBottom: 6, marginTop: 12}}/>
                    {!ins.props.sortLayout && (
                        sortLayout(ins)
                    )}
                    {ins.props.sortLayout && (
                        <>
                            {getSortLayout()}
                        </>
                    )}
                    {searchLayout(ins)}
                    {topPagination(ins)}
                    {selectedNumsLayout(ins)}
                </Row>
            )
        }

        function galleryView(ins, props, state) {
            return (
                <>
                    <Row justify='flex-start' gutter={{xs: 8, sm: 16, md: 24}} style={{marginTop: '16px'}}>
                        {props.galleryView({
                            data: state.data,
                            selectedData: state.selectedItems,
                            getEditUrl: props.getEditUrl,
                            getDetailsUrl: props.getDetailsUrl,
                            getOpenUrl: props.getOpenUrl,
                            deleteFunc: props.deleteData ? ins.deleteData : null,
                            selectFunc: ins.selectData,
                            ins: ins,
                            loading: state.loading,
                            aspectRatioKey: ins.state.aspectRatioKey
                        })}
                    </Row>
                    {bottomPagination(ins)}
                </>
            )
        }

        function tableView(ins, props, state) {
            return (
                <>
                    <div style={{marginTop: 24, marginBottom: 24}}>
                        {props.tableView({
                            data: state.data,
                            selectedData: state.selectedItems,
                            columns: state.columns,
                            getEditUrl: props.getEditUrl,
                            getDetailsUrl: props.getDetailsUrl,
                            getOpenUrl: props.getOpenUrl,
                            deleteFunc: props.deleteData ? ins.deleteData : null,
                            selectArrayFunc: ins.selectDataArray,
                            tableWidth: props.tableWidth,
                            ins: ins,
                            loading: state.loading
                        })}
                    </div>
                    {bottomPagination(ins)}
                </>
            )
        }

        function calendarView(ins, props, state) {
            return props.calendarView({data: state.data})
        }

        function layoutByView(ins, props, state) {
            let layout;
            if (state.viewLayout === GALLERY_LAYOUT) {
                layout = galleryView(ins, props, state)
            } else if (state.viewLayout === CALENDAR_LAYOUT) {
                layout = calendarView(ins, props, state)
            } else {
                layout = tableView(ins, props, state)
            }
            return (
                <>
                    {!props.filtersLayout && filterTagsLayout(ins, props)}
                    {topActionLayout(ins)}
                    {layout}
                </>
            )
        }

        function filterTags(ins, props) {
            const layout = []

            function CapLetter(arr) {
                if (!arr) return
                return arr.charAt(0).toUpperCase() + arr.slice(1);
            }

            Object.keys(ins.state.filters).forEach((key) => {
                if (!ins.state.filters[key]) return
                let tagArray
                const value = ins.state.filters[key].value
                if (value instanceof Array) {
                    tagArray = value
                } else if (value instanceof Object) {
                    tagArray = [value.value]
                } else {
                    tagArray = [value]
                }
                tagArray?.forEach((tag, index) => {
                    if (!tag || !tag.toString()) return
                    const display = ins.state.filters[key].display_value ? ins.state.filters[key].display_value :
                        tag.toString().replaceAll('-', ' ')
                    layout.push(
                        <Tag
                            bordered={false}
                            style={{verticalAlign: 'center', paddingTop: 0, marginTop: 'auto', marginBottom: 'auto'}}
                            key={key + '_' + tag}
                            closable
                            onClose={() => {
                                const filterState = ins.state.filters
                                const value = filterState[key].value
                                if (value instanceof Array) {
                                    const newValue = value.filter((v) => v !== tag)
                                    if (newValue.length === 0) {
                                        delete filterState[key]
                                    } else {
                                        filterState[key].value = newValue
                                    }
                                } else {
                                    delete filterState[key]
                                }
                                ins.setState(
                                    {
                                        filters: filterState
                                    },
                                    ins.updateData
                                )
                            }}
                        >
                            {CapLetter(ins.state.filters[key].text)}&nbsp;&quot;{display}&quot;
                        </Tag>
                    )
                })
            })
            return layout
        }

        function filterTagsLayout(ins, props) {
            if (Object.keys(ins.state.filters).length === 0) return null
            return (
                <Row align='baseline' gutter={{xs: 8, sm: 16, md: 24}}>
                    <Col key={'filter_title'} style={{display: "table"}}>
                        <Title level={4} style={{marginBottom: 0, verticalAlign: 'middle', display: 'table-cell'}}>
                            <FilterFilled style={{verticalAlign: 'middle', height: 24}}/> Filter
                        </Title>
                    </Col>
                    <Col key={'filter_tags'}
                         style={{display: "flex", justifyContent: 'center'}}>{filterTags(ins, props)}</Col>
                    <Col style={{display: "flex", justifyContent: 'center'}}>
                        <Button
                            icon={<ClearOutlined/>}
                            type='link'
                            style={{verticalAlign: 'middle', display: "block", marginBottom: 0}}
                            onClick={() => {
                                ins.clearAllFilter(ins)
                            }}
                        >
                            Clear all filters
                        </Button>
                    </Col>
                </Row>
            )
        }

        function filterLayout(ins, props) {
            if (props.filterOptions && props.filterOptions.length > 0) {
                const layout = []
                props.filterOptions.forEach((option) => {
                    layout.push(
                        getFiltersByType(option.type, {
                            key: option.key || option.filterField || option.type,
                            onChange: (value) => {
                                if (value === null) {
                                    ins.clearAllFilter(ins)
                                } else {
                                    if (option.type === 'order') {
                                        ins.setState(
                                            {
                                                filters: {...value}
                                            },
                                            ins.updateData
                                        )
                                    } else {
                                        ins.setState(
                                            {
                                                filters: {...ins.state.filters, ...value}
                                            },
                                            ins.updateData
                                        )
                                    }
                                }
                            },
                            ...option
                        })
                    )
                })

                return (
                    <>
                        <Row align='middle' gutter={{xs: 8, sm: 16, md: 24}}>
                            <Col key={'filter_buttons'}>{layout}</Col>
                        </Row>
                    </>
                )
            }
            return null
        }

        function filterLayoutByUser(ins, props) {
            const Layout = ins.props.filtersLayout
            return (
                <Layout artistId={props.artistId} onChange={(state) => {
                    ins.setState({
                        filters: {...ins.state.filters, ...state}
                    }, ins.updateData)
                }}/>
            )
        }

        function exportActionListLayout(ins) {
            const data = []
            if (ins.props.exportOptions) {
                if (ins.props.exportOptions.includes(EXPORT_EXCEL)) {
                    data.push({
                        text: 'Export to Excel',
                        icon: <FileExcelOutlined/>,
                        onClick: () => {
                            if (!is_premium_plan(ins.props)) {
                                ins.setState({planModalVisible: true, exportPopoverVisible: false})
                                return
                            }
                            ins.setState({
                                exportModalVisible: {
                                    ...ins.state.exportModalVisible,
                                    excel: true
                                }, exportPopoverVisible: false
                            })
                        }
                    })
                }
                if (ins.props.exportOptions.includes(EXPORT_PDF)) {
                    data.push({text: 'Export to PDF', icon: <FilePdfOutlined/>})
                }
                if (ins.props.exportOptions.includes(EXPORT_INVENTORY_REPORT)) {
                    data.push({
                        text: 'Export to Inventory Report', icon: <FilePdfOutlined/>, onClick: () => {
                            if (!is_premium_plan(ins.props)) {
                                ins.setState({planModalVisible: true, exportPopoverVisible: false})
                                return
                            }
                            ins.setState({exportPopoverVisible: false})
                            ExportInventoryReport(
                                ins.props.artistId,
                                ins.props.role,
                                ins.state.rawData,
                                ins.state.selectedItems,
                                ins.state.filters?.collectionFilter,
                                ins.state.filters?.usedTypeFilter
                            )
                        }
                    })
                }
                if (ins.props.exportOptions.includes(EXPORT_QR_CODE)) {
                    data.push({
                        text: 'Export to QR Code', icon: <QrcodeOutlined />, onClick: () => {
                            if (!is_premium_plan(ins.props)) {
                                ins.setState({planModalVisible: true, exportPopoverVisible: false})
                                return
                            }
                            ins.setState({exportPopoverVisible: false})
                            ExportInventoryQRCode(
                                ins.props.artistId,
                                ins.props.role,
                                ins.state.rawData,
                                ins.state.selectedItems,
                                ins.state.filters?.collectionFilter,
                                ins.state.filters?.usedTypeFilter
                            )
                        }
                    })
                }
            }

            return (
                <List
                    bordered
                    dataSource={data}
                    renderItem={(item, index) => (
                        <List.Item key={index}>
                          <span onClick={item.onClick} style={{fontSize: 14, cursor: 'pointer'}}>
                            {item.icon}&nbsp;{item.text}
                          </span>
                        </List.Item>
                    )}
                />
            )
        }

        function importActionListLayout(ins) {
            if (!ins.props.importOptions) {
                return null
            }
            const data = []
            if (ins.props.importOptions) {
                if (ins.props.importOptions.includes(IMPORT_BULK_UPLOAD)) {
                    data.push({
                        text: 'Bulk Upload and Update',
                        icon: <UploadOutlined/>,
                        onClick: () => {
                            window.location.href = URL_BULK_UPLOAD_UPDATE
                        }
                    })
                }
                if (ins.props.importOptions.includes(IMPORT_ADD_EXCEL)) {
                    data.push({
                        text: 'Bulk Create from Excel',
                        icon: <UploadOutlined/>,
                        onClick: () => {
                            ins.setState({
                                importAddModalVisible: true, importPopoverVisible: false, importModalVisible:false
                            })
                        }
                    })
                }
                if (ins.props.importOptions.includes(IMPORT_EXCEL)) {
                    data.push({
                        text: 'Bulk Update from Excel',
                        icon: <FileExcelOutlined/>,
                        onClick: () => {
                            ins.setState({
                                importModalVisible: true, importPopoverVisible: false, importAddModalVisible: false
                            })
                        }
                    })
                }
            }

            return (
                <List
                    bordered
                    dataSource={data}
                    renderItem={(item, index) => (
                        <List.Item key={index}>
                          <span onClick={item.onClick} style={{fontSize: 14, cursor: 'pointer'}}>
                            {item.icon}&nbsp;{item.text}
                          </span>
                        </List.Item>
                    )}
                />
            )
        }

        function getPageName(name, suffix) {
            if (!name) return ""
            return name.charAt(0).toUpperCase() + name.slice(1) + 's' + suffix
        }

        const titleLevel = 1


        function onSubscriptionChanged(isSubscribed = false, updatedTime=null) {
            this.setState({
                planModalVisible: !isSubscribed
            })
        }

        return (
            <Spin size='large' spinning={this.state.loading || this.state.actionLoading}>
                <PlanExpireModal open={this.state.planModalVisible} logout={this.logout} isUpgrade={true} onClose={()=>{
                    this.setState({planModalVisible: false})
                }} onSubscriptionChanged={onSubscriptionChanged}/>
                <Modal
                    destroyOnClose={true}
                    visible={this.state.exportModalVisible['excel']}
                    title='Export to Excel'
                    onCancel={() => {
                        this.setState({
                            exportModalVisible: {
                                ...this.state.exportModalVisible,
                                'excel': false
                            }
                        })
                    }}
                    footer={null}
                >
                    <ExportExcelColumnsSelect
                        allColumns={this.state.allColumns?.filter((column) => (
                            !this.props.excludedColumns?.includes(column.key)
                        ))}
                        columns={this.state.columns?.filter((column) => (
                            !this.props.excludedColumns?.includes(column.key)
                        ))}
                        rawData={this.state.selectedItems?.length > 0 ? this.state.selectedItems: this.state.rawData}
                        fileName={this.props.exportFileName}/>
                </Modal>
                <Modal
                    width={1000}
                    visible={this.state.importModalVisible}
                    title='Import from Excel'
                    onCancel={() => {
                        this.setState({
                            importModalVisible: false
                        })
                    }}
                    footer={null}
                >
                    <ImportExcelColumnsSelect
                        allColumns={this.state.allColumns?.filter((column) => (
                            !this.props.excludedColumns?.includes(column.key)
                        ))}
                        columns={this.state.columns?.filter((column) => {
                            return !this.props.excludedColumns?.includes(column.key)
                        })}
                        fileName={this.props.name}
                        onImportConfirm={this.bulkEditData}/>
                </Modal>
                 <Modal
                    width={1000}
                    visible={this.state.importAddModalVisible}
                    title='Bulk create from Excel'
                    onCancel={() => {
                        this.setState({
                            importAddModalVisible: false
                        })
                    }}
                    footer={null}
                >
                    <ImportAddExcelColumnsSelect
                        allColumns={this.state.allColumns?.filter((column) => {
                            return !this.props.excludedColumns?.includes(column.key) && column.key !== 'id'
                        })}
                        columns={this.state.columns?.filter((column) => {
                            return !this.props.excludedColumns?.includes(column.key) && column.key !== 'id'
                        })}
                        fileName={this.props.name}
                        onImportConfirm={this.bulkAddData}/>
                </Modal>
                <ManageColumnsModal open={this.state.manageColumnsModalVisible}
                                    selectColumns={this.state.columns}
                                    allColumns={this.state.allColumns}
                                    onSave={(values) => {
                                        let newColumns = []
                                        this.state.allColumns.forEach((column) => {
                                            if (values.includes(column.dataIndex)) {
                                                newColumns.push(column)
                                            }
                                        })
                                        this.setState({
                                            columns: newColumns
                                        })
                                    }}
                                    onClose={() => {
                                        this.setState({manageColumnsModalVisible: false})
                                    }}
                />
                <div className='site-layout-background'>
                    <Row align='baseline' gutter={{xs: 8, sm: 16, md: 24}}
                         style={{marginTop: 12, justifyContent: "space-between"}}>
                        <Col style={{
                            display: 'table', textAlign: "center", height: '100%', marginBottom: 12,
                            marginTop: 12
                        }}>
                            <MyTitle id={'view-title'} level={titleLevel}
                                     style={{}}>{this.state.total} {getPageName(this.props.name, this.props.nameSuffix)}
                            </MyTitle>
                            {this.props.faqLink && (
                                <a
                                    target={'_blank'}
                                    href={this.props.faqLink}
                                    style={{float: 'right',}}
                                    rel='noreferrer'
                                >
                                    Click for instructions
                                </a>
                            )}
                        </Col>
                        {this.props.topActionLayout && (
                            this.props.topActionLayout
                        )}
                        <Col style={{display: 'table', textAlign: "center", height: '100%'}}>
                            {!this.props.disableAdd && (
                                <Button
                                    data-tut="reactour__create"
                                    style={{marginTop: 12, marginBottom: 12, marginRight: 24}}
                                    type={'primary'}
                                    size='large'
                                    onClick={(event) => {
                                        this.props.history.push({pathname: this.props.addNewUrl})
                                    }}
                                >
                                    Create {this.props.name}
                                </Button>
                            )}
                        </Col>
                    </Row>
                    <Row align='baseline' gutter={{xs: 24, sm: 16, md: 24}} style={{marginTop: 18}}>
                        {!this.props.filtersLayout && (
                            <Col xs={24} sm={24} md={9} style={{marginTop: 6}} data-tut="reactour__filters">
                                {filterLayout(this, this.props)}
                            </Col>
                        )}
                        <Col xs={24} sm={24} md={15} style={{marginTop: 6}}>
                            <Row align='baseline' gutter={{xs: 8, sm: 16, md: 24}}>
                                {this.state.viewLayout === GALLERY_LAYOUT && !this.props.disableGalleryRatioOption && (
                                    <Col>
                                        <Dropdown
                                            menu={{
                                                items: viewRatioOptions, selectable: true,
                                                defaultSelectedKeys: [this.state.aspectRatioKey],
                                                onClick: (e) => {
                                                    this.setState({
                                                        aspectRatioKey: e.key
                                                    }, () => {
                                                        this.setCache(KEY_ASPECT_RATIO_KEY + this.props.artistId, e.key)
                                                    })
                                                }
                                            }}
                                            trigger={['click']}
                                        >
                                            <Button data-tut="reactour__view_ratio" size='middle' type={'link'} style={{verticalAlign: 'middle'}}
                                                    onClick={e => (e.preventDefault())}>
                                                <RadiusSettingOutlined /> Aspect ratio <DownOutlined/>
                                            </Button>
                                        </Dropdown>
                                    </Col>
                                )}
                                {this.state.viewLayout === TABLE_LAYOUT && (
                                    <Col>
                                        <Button size='middle' type={'link'} style={{verticalAlign: 'middle'}}
                                                onClick={() => {
                                                    this.setState({manageColumnsModalVisible: true})
                                                }}>
                                            <LayoutOutlined/> Column
                                        </Button>
                                    </Col>
                                )}
                                <Col data-tut="reactour__view_modes">
                                    <Radio.Group
                                        onChange={(e) => {
                                            this.setState({viewLayout: e.target.value})
                                            this.setCache(KEY_VIEW_LAYOUT + this.props.artistId, e.target.value)
                                        }}
                                        defaultValue={this.state.viewLayout}
                                    >
                                        {this.viewOptions.map((option, index) => {
                                            return (
                                                <Radio.Button key={option.toString()} style={{marginBottom: 6}}
                                                              value={option.toString()}>
                                                    {ViewIcons[option.toString()]}
                                                </Radio.Button>
                                            )
                                        })}
                                    </Radio.Group>
                                </Col>
                                <Col data-tut="reactour__export">
                                    <Popover
                                        open={this.state.exportPopoverVisible}
                                        placement='bottomLeft'
                                        onOpenChange={(visible) => {
                                            this.setState({exportPopoverVisible: visible})
                                        }}
                                        title=''
                                        content={exportActionListLayout(this)}
                                        trigger='click'
                                    >
                                        <Button size='middle' style={{verticalAlign: 'middle'}}>
                                            Export
                                        </Button>
                                    </Popover>
                                </Col>
                                {!this.props.disableImport && (
                                    <Col data-tut="reactour__import">
                                        <Popover
                                            open={this.state.importPopoverVisible}
                                            placement='bottomLeft'
                                            onOpenChange={(visible) => {
                                                this.setState({importPopoverVisible: visible})
                                            }}
                                            title=''
                                            content={importActionListLayout(this)}
                                            trigger='click'
                                        >
                                            <Button size='middle' style={{verticalAlign: 'middle'}}>
                                                Import
                                            </Button>
                                        </Popover>
                                    </Col>
                                )}
                            </Row>
                        </Col>
                    </Row>
                    {this.props.filtersLayout && (
                        <Col span={24} style={{marginTop: 12}}>
                            {filterLayoutByUser(this, this.props)}
                        </Col>
                    )}
                    {layoutByView(this, this.props, this.state)}
                </div>
            </Spin>
        )
    }
}

// Setting default values for the props of GalleryTablePanel
GalleryTablePanel.defaultProps = {
    name: 'GalleryTablePanel',
    nameSuffix: '',
    current: 1,
    pageSize: 12,
    pageSizeOptions: [12, 24, 50, 100],
    tableWidth: 1200,
    columnsAction: null,
    faqLink: null,
    sortOptions: [],
    defaultSortOption: null,
    disableAdd: false,
    dataOrderJson: null,
    topActionLayout: null,
    filterOptions: [],
    viewOptions: [GALLERY_LAYOUT, TABLE_LAYOUT, CALENDAR_LAYOUT],
    importOptions: [IMPORT_EXCEL],
    disableImport: false,
    exportOptions: [EXPORT_EXCEL],
    excludedColumns: [],
    galleryView: (props) => {
        return <GalleryView {...props}/>
    },
    tableView: (props) => {
        return <TableView {...props}/>
    },
    calendarView: (props) => {
        return <CalendarView {...props}/>
    },
    sortLayout: null,
    filtersLayout: null,
    exportFileName: 'revart',
    disableGalleryRatioOption: false,
    disableSearch: false
};

// Typechecking props for the GalleryTablePanel
GalleryTablePanel.propTypes = {
    // basic
    artistId: PropTypes.string,
    role: PropTypes.string,
    name: PropTypes.string,
    nameSuffix: PropTypes.string,
    faqLink: PropTypes.string,
    disableAdd: PropTypes.bool,
    disableSearch: PropTypes.bool,
    dataOrderJson: PropTypes.string,
    topActionLayout: PropTypes.node,
    // getAll / delete
    requestData: PropTypes.func,
    deleteData: PropTypes.func,
    // bulk action apis
    bulkAddData: PropTypes.func,
    bulkUpdateData: PropTypes.func,
    bulkDelete: PropTypes.func,
    // get / edit
    getOpenUrl: PropTypes.func,
    getEditUrl: PropTypes.func,
    getDetailsUrl: PropTypes.func,
    // pagination
    current: PropTypes.number, // the current page index
    pageSize: PropTypes.number,  // the number of items of each page
    pageSizeOptions: PropTypes.array, // the page size options array
    // actions
    sortOptions: PropTypes.array,   // the sort options array
    filterOptions: PropTypes.array, // the filter options array
    viewOptions: PropTypes.arrayOf(PropTypes.string), // the view options array
    defaultSortOption: PropTypes.string,
    disableGalleryRatioOption: PropTypes.bool,
    // layout component
    filtersLayout: PropTypes.func,
    sortLayout: PropTypes.node,
    // views
    galleryView: PropTypes.func,
    tableView: PropTypes.func,
    calendarView: PropTypes.func,
    // list view
    columns: PropTypes.array,
    allColumns: PropTypes.array,
    columnsAction: PropTypes.array,
    tableWidth: PropTypes.number,
    // exporting
    excludedColumns: PropTypes.array,
    exportFileName: PropTypes.string,
    exportOptions: PropTypes.array,
    // importing
    importOptions: PropTypes.array,
    disableImport: PropTypes.bool
};

export default withRouter(GalleryTablePanel)